import styled from 'styled-components'
import { useTransition, animated, config } from '@react-spring/web'
import { SourceArticle } from './SourceArticle'

export const SourceArticles = ({ articles }: { articles: any }) => {
  const articlesTransitions = useTransition(
    articles.size > 0 ? [...articles.values()] : [],
    {
      keys: (item) => (item ? item.id : ''),
      from: { opacity: 0, maxHeight: 0 },
      enter: { opacity: 1, maxHeight: 200 },
      leave: { opacity: 0, maxHeight: 0 },
      update: { maxHeight: 200 },
      config: config.stiff,
      trail: 300,
    }
  )

  const Article = animated(SourceArticle)

  return (
    <Container>
      <SegmentTitle>En détail:</SegmentTitle>
      <ArticlesContainer>
        <Articles>
          {articlesTransitions((style, item) => {
            const articleImage = new Image()
            articleImage.src = item.imageSrc

            return (
              <Article
                metadataId={item.id}
                title={item.title}
                header={item.titleHeader}
                imageSrc={item.imageSrc}
                targetUrl={item.url}
                isPremium={item.isPremium}
                key={item.id}
                style={style}
              />
            )
          })}
        </Articles>
      </ArticlesContainer>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  margin-top: 2rem;
`

const SegmentTitle = styled.div`
  font-size: 1.25rem;
  text-transform: uppercase;
  font-weight: 700;
`

const ArticlesContainer = styled.div`
  height: 100%;
  position: relative;

  &:after {
    pointer-events: none;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 20%;
    height: 100%;
  }
`

const Articles = styled.div`
  background: ${({ theme }) => theme.colorSiteBackground};
  border: 1px solid ${({ theme }) => theme.colorGrey};
  padding: 2rem;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
  white-space: nowrap;
  position: relative;
  box-sizing: border-box;
  width: 100%;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`
